import { Model } from '@/models/Model';

export class Library extends Model {
  protected $name = 'Library';

  protected $endpoint = '/hin/library';

  protected $primaryKey = 'uuid';

  protected $fillable: string[] = ['file', 'file_name', 'description', 'hin_show_to_all'];

  public uuid?: string;

  public file?: string;

  public file_name?: string;

  public description?: string;

  public hin_show_to_all?: boolean;

  public get_url?: boolean;

  public listMedia(): Promise<this[]> {
    const url = this.$endpoint;

    return this.request('get', url, {}, 'media');
  }

  public getFile(id: string): any {
    const url = `${this.$endpoint}/${id}/url`;
    return this.request('get', url, {}, 'media');
  }
}
